export const SESSION_USECASE_TYPE = {
  MEGA_PTM: "MEGA_PTM",
  ListeningActivity: "listening-activity",
  YLC: "YLC",
  ParentPerceptionSurvey: "parent_perception_survey",
}

export const DEFAULT_COMPANY_SLUG = "shikshalokamstaging"

export const sessionFlowName = {
  GuestDiscussion: "guest-discussion",
  LoginDiscussion: "login-discussion",
  GuestMiStory: "guest-mi-story",
  LoginMiStory: "login",
  SsoFlow: "guest-mi-story",
  Reflection: "reflection",
  megaPTM: "megaPTM",
  YLC: "YLC",
  ListeningActivity: "listening-activity",
  ParentPerceptionSurvey: "parent_perception_survey",
  Creation: "creation",
  LFA: "lfa",
  LCF: "lcf",
  FreeFlow: "free_flow",
  ShikshaSamvad: "shiksha-samvad",
  DelhiShikshaSamvad: "delhi-shiksha-samvad",
  StudyTeacherInterview: "study_teacher_interview",
  BiharStudentFGD: "bihar-student-fgd",
  OdishaYouth: "odisha-youth",
  OdishaYouthAI: "odisha-youth-ai",
  TelanganaPTMPilot: "telangana-ptm-pilot",
  StakeholderFGD: "stakeholder-fgd",
  CommunityFGD: "community-fgd",
  XylemX_entrepreneurship_development: "XylemX_entrepreneurship_development",
  PPPI_BOT_1: "PPPI_Set_1",
  PPPI_Set_2: "PPPI_Set_2",
  Bihar_PTM: "Bihar_PTM",
  SanjhiSikhiyaStoryBot: "sanjhi_sikhiya_story_bot",
  SanjhiSikhiyaDiscussionBot: "sanjhi_sikhiya_discussion_bot",
  Youth_21_25: "youth_21-25",
  Youth_12_20: "youth_12-20",
  Education_House_Conversation: "Education_House_Conversation",
  General_Public_Voice: "General_Public_Voice",
  One_Million_Youth: "Youth_Voice",
  Parent_Voice: "Parent_Voice"
}

export const STATE_MACHINE_OPERATION_TYPE = {
  NON_LLM: "non_llm",
  LLM: "llm"
}

export const FINISH_REASON_SOCKET = "stop"

export const CONVERSATION_USER_TYPES = {
    USER: "user",
    BOT: "bot"
}
